import { memo } from 'react';

import { FileStatusButton, FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type AssetCustomFieldValueUpdateTaskFailedPanelItemProps = {
  onClear: () => void;
};

export const AssetCustomFieldValueUpdateTaskFailedPanelItem = memo(
  ({ onClear }: AssetCustomFieldValueUpdateTaskFailedPanelItemProps) => {
    return (
      <PaneItemTW
        avatar={<FileStatusIconErrored />}
        title={
          <FileStatusTitle data-testid="ASSET_CUSTOM_FIELD_VALUE_UPDATE_TASK_FAILED_PANEL_ITEM_TITLE">
            Failed to update custom fields
          </FileStatusTitle>
        }
        buttons={
          <FileStatusButton label="Clear" onClick={onClear}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

AssetCustomFieldValueUpdateTaskFailedPanelItem.displayName = 'AssetCustomFieldValueUpdateTaskFailedPanelItem';
